<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/sender/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Senders
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> Sender
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertSenderFrom"
    (ngSubmit)="onUpsertSender()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <mat-card-title>Sender Details</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div *appHasPlatformAccess class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onPartnerSelected($event)"
                [inputData]="attrConstant.partner"
                [selectOptions]="partnerList | async"
                [bindLabel]="'name'"
                [bindValue]="'partner_id'"
                [formControlName]="attrConstant.partner.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onSourceCountrySelected($event)"
                [inputData]="attrConstant.sourceCountry"
                [selectOptions]="sourceCountryList | async"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.sourceCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.firstName"
                [formControlName]="
                  attrConstant.firstName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.middleName"
                [formControlName]="
                  attrConstant.middleName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.lastName"
                [formControlName]="
                  attrConstant.lastName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.nationality"
                [selectOptions]="countryList | async"
                [bindLabel]="'country_name'"
                [bindValue]="'alpha3'"
                [formControlName]="
                  attrConstant.nationality.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.gender"
                [selectOptions]="gender"
                [bindLabel]="'name'"
                [bindValue]="'value'"
                [formControlName]="attrConstant.gender.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                (passwordChanged)="patchPassword($event)"
                [inputData]="attrConstant.password"
                [formControlName]="
                  attrConstant.password.key
                "></app-input-template>
            </div>
            <div class="col-md-6">
              <app-input-datepicker
                [inputData]="attrConstant.dob"
                [formControlName]="attrConstant.dob.key"></app-input-datepicker>
            </div>
          </div>
        </mat-card>
        <mat-card formArrayName="documents" class="my-2">
          <mat-card-title>Sender ID Details</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div *ngFor="let document of documentData.controls; let i = index">
            <mat-divider
              *ngIf="documentData.controls.length > 1 && i > 0"
              class="position-relative my-3"></mat-divider>
            <div [formGroupName]="i">
              <div class="row">
                <div class="col-md-6 form-group">
                  <app-input-select
                    [inputData]="attrConstant.docType"
                    [selectOptions]="documentType"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.docType.key
                    "></app-input-select>
                </div>
                <div class="col-md-6 form-group">
                  <app-input-select
                    [inputData]="attrConstant.docSection"
                    [selectOptions]="documentSection"
                    [bindLabel]="'name'"
                    [bindValue]="'value'"
                    [formControlName]="
                      attrConstant.docSection.key
                    "></app-input-select>
                </div>
                <div class="col-md-6 form-group">
                  <app-input-template
                    [inputData]="attrConstant.docNumber"
                    [formControlName]="
                      attrConstant.docNumber.key
                    "></app-input-template>
                </div>
                <div class="col-md-6 form-group">
                  <app-input-datepicker
                    [inputData]="attrConstant.docExpiryDate"
                    [formControlName]="
                      attrConstant.docExpiryDate.key
                    "></app-input-datepicker>
                </div>
                <div class="col-md-6 form-group">
                  <app-input-file
                    (chooseDocument)="onChooseDocument($event, i)"
                    [inputData]="attrConstant.image"
                    [formControlName]="attrConstant.image.key"></app-input-file>
                </div>
                <div
                  class="col-md-1 d-flex align-items-center justify-content-end ms-auto ps-0"
                  *ngIf="documentData.controls.length > 1">
                  <a
                    (click)="removeDocumentRow(i)"
                    mat-stroked-button
                    color="warn"
                    class="dlt-btn border-0"
                    [attr.aria-hidden]="true">
                    <mat-icon class="m-0">delete forever</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="mt-3"></mat-divider>
          <mat-card-actions class="row mt-3 d-flex justify-content-end">
            <div class="col-md-3 text-end">
              <a
                mat-stroked-button
                class="ubx-primary"
                [attr.aria-hidden]="true"
                (click)="addDocumentRow()">
                + Add New ID
              </a>
            </div>
          </mat-card-actions>
        </mat-card>
        <mat-card>
          <mat-card-title>Contact Details</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address1"
                [formControlName]="
                  attrConstant.address1.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address2"
                [formControlName]="
                  attrConstant.address2.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.city"
                [formControlName]="attrConstant.city.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.postalCode"
                [formControlName]="
                  attrConstant.postalCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.email"
                [formControlName]="attrConstant.email.key"></app-input-template>
            </div>
          </div>
          <div class="row">
            <div class="col-md-1 col-2 form-group">
              <app-input-template
                [inputData]="attrConstant.mobileCode"
                [formControlName]="
                  attrConstant.mobileCode.key
                "></app-input-template>
            </div>
            <div class="col-md-5 col-10 form-group ps-0">
              <app-input-template
                [inputData]="attrConstant.mobileNumber"
                [formControlName]="
                  attrConstant.mobileNumber.key
                "></app-input-template>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
